var _path, _path2, _circle, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoLeadPages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11C30.54 11 33 8.54 33 5.5C33 2.46 30.54 0 27.5 0C24.46 0 22 2.46 22 5.5C22 8.54 24.46 11 27.5 11ZM27.5 2C29.43 2 31 3.57 31 5.5C31 7.43 29.43 9 27.5 9C25.57 9 24 7.43 24 5.5C24 3.57 25.57 2 27.5 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19H44.93C44.44 15.05 41.08 12 37 12C32.92 12 29.56 15.05 29.07 19H22.79C22.93 18.52 23 18.02 23 17.5C23 14.46 20.54 12 17.5 12C14.46 12 12 14.46 12 17.5C12 18.02 12.08 18.52 12.21 19H9C7.9 19 7 19.91 7 21.02V25.05C7 25.69 7.3 26.3 7.82 26.68L21.19 36.6C21.7 36.98 22.01 37.59 22.01 38.23V47.96C22.01 49.14 22.97 49.99 24.01 49.99C24.33 49.99 24.65 49.91 24.97 49.74L31.97 45.88C32.61 45.53 33.01 44.84 33.01 44.1V38.34C33.01 37.63 33.37 36.98 33.97 36.61L50.06 26.66C50.65 26.29 51.02 25.64 51.02 24.93V21.01C51.02 19.89 50.12 18.99 49.02 18.99L49 19ZM30.99 44.14L24 47.98V38.25C24 36.98 23.39 35.77 22.37 35.01L9 25.06V21H49V24.97L32.91 34.92C31.73 35.65 31 36.96 31 38.35V44.13L30.99 44.14ZM37 14C39.97 14 42.43 16.17 42.91 19H31.09C31.57 16.17 34.03 14 37 14ZM14 17.5C14 15.57 15.57 14 17.5 14C19.43 14 21 15.57 21 17.5C21 18.04 20.87 18.54 20.65 19H14.35C14.13 18.54 14 18.04 14 17.5Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 11,
    fill: "#25BB73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.1152,
    y: 46.8223,
    width: 1.5,
    height: 7.58759,
    rx: 0.75,
    transform: "rotate(-45 40.1152 46.8223)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.48,
    y: 52.1875,
    width: 1.5,
    height: 11.9926,
    rx: 0.75,
    transform: "rotate(-135 45.48 52.1875)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoLeadPages);
export default __webpack_public_path__ + "static/media/autoLeadPages.182b23566ba0ae63a2f190556ba16a6a.svg";
export { ForwardRef as ReactComponent };